export const api = {
  getServices: "/services",
  getTeamMembers: "/team-members/public",
  getProjects: "/projects",
  getBlogs: "/blogs",
  getCompanyProfile: "/company-profile/public",
  getJobs: "/jobs/public",
};
